import {Observable} from 'rxjs';
import {CpmCJobsInstanceApiModel} from '../../models/c-global/cpmc-jobs-instance.api-model';
import {CpmCApiBridge} from '../../../../../src/app/cpmc-api-bridge';
import {CpmCQueryPaginatorConfig, CpmCQueryPaginatorConfigUtils} from '../../cpmc-defines';
import {AllowedQueryParamTypes, QueryParams} from '../../../../../sdk/src/utils/query.utils';
import {CpmCPaginatedResultAPISchema} from '../../schemas/cpmc-paginated-result.api-schemas';

export type CpmCGetJobsInstanceListParams = {
    [K in keyof CpmCJobsInstanceApiModel]?: CpmCJobsInstanceApiModel[K] extends AllowedQueryParamTypes
        ? CpmCJobsInstanceApiModel[K]
        : never;
} & {} & QueryParams;

/**
 * JobsInstance Api Service
 */
export class CpmCJobsInstanceApiService {
    public static readonly dPaginatorConfig: CpmCQueryPaginatorConfig = {limit: -1, sort: 'name', order: 1};

    // ===============================================================
    // ===============================================================

    public static baseUrl() {
        return CpmCApiBridge.getBackendBaseURL() + 'api/core/v1/jobs-instance';
    }

    // ===============================================================
    // ===============================================================

    public static endpointList(): string {
        return `${CpmCJobsInstanceApiService.baseUrl()}/list`;
    }
    public static endpointGet(jobsInstanceUUID: string): string {
        return `${CpmCJobsInstanceApiService.baseUrl()}/${jobsInstanceUUID}`;
    }

    // ===============================================================
    // ===============================================================

    public static getJobsInstanceList(
        params: CpmCGetJobsInstanceListParams = {},
        paginatorConfig: CpmCQueryPaginatorConfig = CpmCJobsInstanceApiService.dPaginatorConfig
    ): Observable<CpmCPaginatedResultAPISchema<CpmCJobsInstanceApiModel>> {
        return CpmCApiBridge.httpGet<CpmCPaginatedResultAPISchema<CpmCJobsInstanceApiModel>>(
            CpmCJobsInstanceApiService.endpointList(),
            {
                ...(params as QueryParams),
                ...CpmCQueryPaginatorConfigUtils.toQueryParams(paginatorConfig)
            }
        );
    }
    public static getJobsInstanceByUUID(jobsInstanceUUID: string): Observable<CpmCJobsInstanceApiModel> {
        return CpmCApiBridge.httpGet<CpmCJobsInstanceApiModel>(
            CpmCJobsInstanceApiService.endpointGet(jobsInstanceUUID)
        );
    }
}
